import UsersService from '@/services/UsersService';

export default {
    state() {
        return {
            authToken: null,
            userAvatar: {},
            userContacts: [],
            userNewBadge: {},
            user: {},
            userCompany: {},
            userOriginalData: {},
            newUser: {},
            usersData: [],
            usersTotalAmountBasedInRole: {},
            academicRoles: ['student', 'teacher', 'tutor'],
            accessAsPointerCardPosition: {
                top: 0,
                left: 0
            },
        }
    },

    getters: {
        getUserNewBadgeState: (state) => {
            if (typeof state.userNewBadge === 'object' && Object.keys(state.userNewBadge).length > 0) return true
            return false
        },
        getUserNewBadge: (state) => state.userNewBadge,
        getUserPoints: (state) => state?.user?.points || '0',
        getAccessAsPointerCardPosition: (state) => state.accessAsPointerCardPosition,
        getAccessAsState: (state) => {
            if (typeof state.userOriginalData !== 'object') return false
            const userOriginalKeys = Object.keys(state.userOriginalData)
            return userOriginalKeys.length > 0 ? true : false
        },
        getId: (state) => state?.user?.id,
        getName: (state) => state?.user?.name,
        getType: (state) => state?.user?.type,
        getCompany: (state) => state?.userCompany,
        getToken: (state) => state?.authToken,
        getAvatarData: (state) => state.userAvatar,
        getUserBelongsToAcademicRoles: (state) => state.academicRoles.includes(state?.user?.type),
        getAcademicRoles: (state) => state.academicRoles,
        getUserContacts: (state) => state.userContacts,
        getUserData: (state) => state?.user,
        getUserType: (state) => state.user.type,
        getUserEmail: (state) => state.user.email,
        getUserCompanies: (state) => state.user.companies,
        getUsersData: (state) => state.usersData,
        getCompanyProMode: (state) => Boolean(state?.userCompany.pro_mode),
        getUsersTotalAmountBasedInRole: (state) => state.usersTotalAmountBasedInRole
    },

    mutations: {
        setUserNewBadge(state, data) {
            if (data !== null && data !== undefined && typeof data === 'object' && Object.keys(data).length > 0) {
                state.userNewBadge = data
                return
            }

            state.userNewBadge = {}
        },

        incrementUserPoints(state, data) {
            if (state?.user?.points !== null && state?.user?.points !== undefined && data) {
                state.user.points = Number(state.user.points) + Number(data)
            }
        },

        setAcademicRoles(state) {
            state.academicRoles = ['teacher', 'student', 'tutor']
        },

        setUserCompany(state, data) {
            if (data && typeof data === 'object' && Object.keys(data).length > 0) {
                state.userCompany = data
            }
        },

        setAuthToken(state, token) {
            state.authToken = token || null
        },

        updateUserContacts(state, data) {
            if (Array.isArray(data) && data.length > 0) {
                data.forEach((contactUpdated) => {
                    const contactIndex = state.userContacts
                        .findIndex((contactCreated) => contactCreated?.id === contactUpdated?.id)
                    contactIndex !== -1 && (state.userContacts[contactIndex] = contactUpdated)
                })
            }
        },

        createUserContacts(state, data) {
            Array.isArray(data) && (state.userContacts = [...(state?.userContacts || []), ...data])
        },

        deleteUserContact(state, data) {
            if (Array.isArray(data) && data.length > 0) {
                data.forEach((contactToDeleteID) => {
                    const contactIndex = state.userContacts.findIndex((contact) => contact.id === contactToDeleteID)
                    contactIndex !== -1 && (state.userContacts.splice(contactIndex, 1))
                })
            }
        },

        setUserContacts(state, data) {
            state.userContacts = data || []
        },

        setUserCompanies(state, companies) {
            const validObject = companies && typeof companies === 'object' && Object.keys(companies).length > 0
            state.user.companies = validObject ? companies : {}
        },
        setNewUserData(state, data) {
            state.newUser.id = data?.id || null;
            state.newUser.name = data?.name || null;
            state.newUser.type = data?.type || null;
            state.newUser.email = data?.email || null;
            state.newUser.companies = data?.companies || null;
        },

        resetUserData(state) {
            state.user = {}
            state.userAvatar = {}
            state.userOriginalData = {}
            state.userContacts = []
            state.authToken = null
        },

        setUserOriginalData(state) {
            const objectKeys = typeof state.userOriginalData === 'object' ?
                Object.keys(state.userOriginalData)
                : []

            if (objectKeys.length > 0) {
                const { avatar, token, contacts, ...rest } = state.userOriginalData

                state.user = rest
                state.userAvatar = avatar
                state.userContacts = contacts
                state.authToken = token

                state.userOriginalData = {}
            }
        },

        setAccessAsUserData(state, data) {
            if (data && typeof data === 'object' && Object.keys(data).length > 0) {
                const { address, country, session, students_count,
                    last_activity, followers, following, postal_code,
                    profile_picture, disciplines_count, ...rest } = data

                state.userOriginalData = rest
            }
        },

        setUserData(state, data) {
            const { address, country, session, students_count, token, company,
                avatar, contacts, last_activity,
                followers, following, postal_code,
                profile_picture, disciplines_count, ...rest } = data

            state.user = rest
            state.userAvatar = avatar
            state.userContacts = contacts
        },

        updateUserAvatar(state, data) {
            if (data && typeof data === 'object' && Object.keys(data).length > 0) {
                state.userAvatar = data
            }
        },

        clearNewUserData(state) {
            state.newUser.id = "";
            state.newUser.name = "";
            state.newUser.type = "";
            state.newUser.email = "";
            state.newUser.companies = "";
        },

        setUsersData(state, data) {
            state.usersData = data
        },

        setUsersTotalAmountBasedInRole(state, data) {
            if (typeof data === 'object' && Object.keys(data).length > 0) {
                state.usersTotalAmountBasedInRole = {
                    users: data?.total_users || 0,
                    student: data?.total_students || 0,
                    tutor: data?.total_tutors || 0
                }
            }
        },

        pushUserData(state, user) {
            if (user && typeof user === 'object' && Object.keys(user).length > 0) {
                const existingUserIndex = state.usersData.findIndex(u => u.id === user.id);
                if (existingUserIndex !== -1) {
                    state.usersData[existingUserIndex] = user;
                } else
                    state.usersData.push(user);
            }
        },

        popUserData(state, userId) {
            const index = state.usersData.findIndex(user => user.id === userId);
            if (index !== -1) {
                state.usersData.splice(index, 1);
            }
        },

        updateAccessAsPointerCardPosition(state, data) {
            state.accessAsPointerCardPosition.top = data?.top || 0
            state.accessAsPointerCardPosition.left = data?.left || 0
        },
    },

    actions: {
        setUserNewBadge({ commit }, payload) {
            commit('setUserNewBadge', payload)
        },

        incrementUserPoints({ commit }, payload) {
            commit('incrementUserPoints', payload)
        },

        setAcademicRoles({ commit }) {
            commit('setAcademicRoles')
        },

        setUserOriginalData({ commit }) {
            commit('setUserOriginalData')
            commit('updateAccessAsPointerCardPosition')
        },

        updateAccessAsPointerCardPosition({ commit }, payload) {
            commit('updateAccessAsPointerCardPosition', payload)
        },

        resetUserDataUserModule({ commit }) {
            commit('resetUserData')
            commit('updateAccessAsPointerCardPosition')
        },

        setAccessAsUserData({ commit }, payload) {
            commit('setAccessAsUserData', payload)
        },

        setUserDataUserModule({ commit }, payload) {
            commit('setUserData', payload)
            commit('setAuthToken', payload?.token)
            commit('setUserCompany', payload?.company)
        },

        setUserCompanies({ commit }, data) {
            commit("setUserCompanies", data?.companies);
        },

        async findUserCompanies({ commit }, payload) {
            try {
                const response = await UsersService.findUser(payload, payload.userToken);

                const companies = response.data.companies;

                commit('setUserCompanies', companies);

                return { companies };
            } catch (error) {
                console.error('Erro ao buscar informações do usuário:', error);
                throw error;
            }
        },

        async findUser({ commit }, payload) {
            try {
                const response = await UsersService.findUser(payload);

                if (payload?.updateMainUserInStore) {
                    commit('setUserData', response.data);
                }

                return response.data;
            } catch (error) {
                console.error('Erro ao buscar informações do usuário:', error);
                throw error;
            }
        },

        async createUser({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.createUser(payload.user, payload.userToken);

                commit('setNewUserData', response?.data);
                commit('pushUserData', response?.data);

                dispatch('toastfy/activeSuccesNotification', { text: "Usuário criado com sucesso!" })
                return response;
            } catch (error) {
                console.error('Erro ao adicionar usuário:', error);
                let message = "Erro ao criar usuário: " + (error.response?.data?.message ?? "erro desconhecido");

                dispatch('toastfy/activeErrorNotification', { text: message });
                throw error;
            }
        },

        async updateUser({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.updateUser(payload.user, payload.userToken);

                if (payload?.updateMainUser) {
                    commit('setUserData', response.data)
                    return response
                }

                commit('setNewUserData', response.data);
                commit('pushUserData', response.data);

                dispatch('toastfy/activeSuccesNotification', { text: "Usuário atualizado com sucesso!" });
                return response;
            } catch (error) {
                console.error('Erro ao atualizar usuário:', error);
                let message = "Erro ao atualizar usuário: " + (error.response?.data?.message ?? "erro desconhecido");

                dispatch('toastfy/activeErrorNotification', { text: message });
                throw error
            }
        },

        async deleteUser({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.deleteUser(payload.userId, payload.userToken);

                commit('clearNewUserData');
                commit('popUserData', payload?.userId);

                dispatch('toastfy/activeSuccesNotification', { text: "Usuário deletado com sucesso!" });

                return response;
            } catch (error) {
                console.error('Erro ao atualizar usuário:', error);
                let message = "Erro ao deletar usuário: " + (error.response?.data?.message ?? "erro desconhecido");

                dispatch('toastfy/activeErrorNotification', { text: message });
                throw error;
            }
        },

        async getUsers({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.getUsers(payload.data, payload.userToken);
                commit('setUsersData', response?.data);
                commit('setUsersTotalAmountBasedInRole', response?.metrics)

                return response.data;
            } catch (error) {
                console.error('Erro ao procurar usuários:', error);
                throw error;
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async changePassword({ commit }, payload) {
            try {
                const response = await UsersService.changePassword(payload.data, payload.userToken);

                return response.data;
            } catch (error) {
                console.error('Erro ao alterar senha:', error);
                throw error;
            }
        },

        /* eslint-disable no-unused-vars */
        async pingUser({ commit }, payload) {

            try {
                await UsersService.pingUser(payload.userToken);
            } catch (error) {
                throw error;
            }
        },
        /* eslint-enable no-unused-vars */

        async createUserContacts({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.createUserContacts(payload)
                commit('createUserContacts', response.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                throw error
            }
        },

        async updateUserContacts({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.updateUserContacts(payload)
                commit('updateUserContacts', response.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                throw error
            }
        },

        async deleteUserContacts({ commit, dispatch }, payload) {
            try {
                await UsersService.deleteUserContacts(payload)
                commit('deleteUserContact', payload?.contacts_ids || [])
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                throw error
            }
        },

        async getUserContacts({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.getUserContacts(payload)
                commit('setUserContacts', response?.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                throw error
            }
        },

        async initiliazeUserReverbConnection({ dispatch }, userId) {
            try {
                const channel = `users.${userId}`
                const events = [
                    { eventName: '.badge.added', storeAction: 'setUserNewBadge', objectField: 'badge', actionRelatedToModules: true },
                    { eventName: '.points.added', storeAction: 'incrementUserPoints', objectField: 'points', actionRelatedToModules: true },
                    { eventName: '.watermark.created', storeAction: 'setMaterialItemURL', objectField: 'url', actionRelatedToModules: false },
                    { eventName: '.grades.synced', storeAction: 'handleGradesSynced', objectField: 'discipline', actionRelatedToModules: true }
                ]

                await UsersService.initiliazeUserReverbConnection(channel, events)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async updateUserAvatar({ commit, dispatch }, payload) {
            try {
                const response = await UsersService.updateUserAvatar(payload)
                commit('updateUserAvatar', response?.data || null)
                dispatch('toastfy/activeSuccesNotification', { text: "Avatar atualizado com sucesso!" })
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                return false
            }
        },

        handleGradesSynced({ dispatch }, disciplineData) {
            const disciplineName = disciplineData?.name || 'Disciplina'
            dispatch('toastfy/activeSuccesNotification', { text: `As notas da disciplina "${disciplineName}" foram sincronizadas com sucesso!` })
        }
    }
}
